// Maps between the IDP admin service account wire shapes and the feature domain
// types — the single boundary where the wire shape is known.
import type {
  NewServiceAccountRequest,
  ServiceAccountResponse,
  UpdateServiceAccountRequest,
} from '@/api/serviceAccounts.types'
import type { ServiceAccount, ServiceAccountInput } from '../types'

export function toServiceAccount(response: ServiceAccountResponse): ServiceAccount {
  return {
    id: response.clientId,
    name: response.name,
    clientEmail: response.clientEmail,
    issuedOn: response.issuedOn == null ? '' : String(response.issuedOn),
  }
}

export function toNewRequest(input: ServiceAccountInput): NewServiceAccountRequest {
  return { name: input.name, emailLocalPart: input.emailLocalPart }
}

export function toUpdateRequest(input: ServiceAccountInput): UpdateServiceAccountRequest {
  return { name: input.name }
}

export function toInput(account: ServiceAccount): ServiceAccountInput {
  return { name: account.name, emailLocalPart: '' }
}
